import React from 'react';

function About() {
  return (
    <section className="about">
      <div className="hero about-hero">
        <div className="hero-overlay">
          <h1>About Heifersaero</h1>
          <p>Delivering precision-engineered aero spare parts since 2010.</p>
        </div>
      </div>
      <main className="content">
        <div className="about-container">
          <h2>Our Mission</h2>
          <p className="about-subtitle">
            At Heifersaero, we’re committed to keeping the aviation industry soaring with top-quality spare parts and unparalleled service.
          </p>
          <div className="about-sections">
            <div className="about-card">
              <h3>Our Story</h3>
              <p>
                Founded by aviation enthusiasts, Heifers Aero started with a vision to supply reliable, high-performance components to aircraft operators worldwide. Over a decade later, we’re a trusted name in the industry.
              </p>
            </div>
            <div className="about-card">
              <h3>Expertise</h3>
              <p>
                Our team of engineers and specialists ensures every part meets rigorous standards, from turbines to fasteners. Precision is our promise.
              </p>
            </div>
            <div className="about-card">
              <h3>Global Reach</h3>
              <p>
                Based in [Your Location], we serve clients across continents, delivering parts on time, every time, to keep fleets airborne.
              </p>
            </div>
          </div>
          <div className="cta-section">
            <h3>Ready to Fly with Us?</h3>
            <a href="/contact" className="cta-btn">Contact Us Today</a>
          </div>
        </div>
      </main>
    </section>
  );
}

export default About;